<template>
  <ul
    class="navbar-nav bg-gradient-success sidebar sidebar-dark accordion"
    id="accordionSidebar"
  >
    <router-link
      :to="'/'"
      class="sidebar-brand d-flex align-items-center justify-content-center"
    >
      <div class="sidebar-brand-text mx-3">AamCart</div>
    </router-link>
    <hr class="sidebar-divider my-0" />
    <li class="nav-item active" v-if="admin">
      <router-link :to="'/admin/dashboard'" class="nav-link">
        <i class="fa fa-fw fa-dashboard"></i>
        <span>Dashboard</span></router-link
      >
    </li>
    <li class="nav-item active" v-if="vendor">
      <router-link :to="'/vendor/dashboard'" class="nav-link">
        <i class="fa fa-fw fa-dashboard"></i>
        <span>Dashboard</span></router-link
      >
    </li>
    <li class="nav-item active" v-if="packer">
      <router-link :to="'/packer-dashboard'" class="nav-link">
        <i class="fa fa-fw fa-dashboard"></i>
        <span>Dashboard</span></router-link
      >
    </li>
    <li class="nav-item active" v-if="delivery">
      <router-link :to="'/delivery-dashboard'" class="nav-link">
        <i class="fa fa-fw fa-dashboard"></i>
        <span>Dashboard</span></router-link
      >
    </li>
    <div v-if="admin">
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">
        Admin
      </div>
      <li class="nav-item">
        <router-link :to="'/admin/users'" class="nav-link">
          <i class="fa fa-users"></i>
          <span>Users</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/admin/customerlist'" class="nav-link">
          <i class="fa fa-fw fa-user"></i>
          <span>Customers</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/admin/order'" class="nav-link">
          <i class="fa fa-fw fa-shopping-cart"></i>
          <span>Orders</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/coupons'" class="nav-link">
          <i class="fa fa-tag fa-lg"></i>
          <span>Coupons</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/admin/vendor'" class="nav-link">
          <i class="fa fa-fw fa-industry"></i>
          <span>Vendors</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/category-admin'" class="nav-link">
          <i class="fa fa-fw fa-industry"></i>
          <span>Categories</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/admin/products'" class="nav-link">
          <i class="fa fa-fw fa-qq"></i>
          <span>Products</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/vendor/products'" class="nav-link">
          <i class="fa fa-fw fa-qq"></i>
          <span>Vendor Products</span>
        </router-link>
      </li>
    </div>
    <div v-if="vendor">
      <div class="sidebar-heading">
        Vendor
      </div>
      <li class="nav-item">
        <router-link :to="'/vendor/' + vendorId + '/users'" class="nav-link">
          <i class="fa fa-users"></i>
          <span>Users</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/admin/customerlist'" class="nav-link">
          <i class="fa fa-fw fa-user"></i>
          <span>Customers</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/vendor/' + vendorId + '/order'" class="nav-link">
          <i class="fa fa-fw fa-shopping-cart"></i>
          <span>Orders</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="'/vendor/' + vendorId + '/products'" class="nav-link">
          <i class="fa fa-fw fa-qq"></i>
          <span>Products</span>
        </router-link>
      </li>
    </div>
    <div v-if="packer">
      <li class="nav-item">
        <router-link :to="'/vendor/packer'" class="nav-link">
          <i class="fa fa-fw fa-shopping-cart"></i>
          <span>Orders</span>
        </router-link>
      </li>
    </div>
    <div v-if="delivery">
      <li class="nav-item">
        <router-link :to="'/delivery/order'" class="nav-link">
          <i class="fa fa-fw fa-shopping-cart"></i>
          <span>Orders</span>
        </router-link>
      </li>
    </div>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vendor: false,
      admin: false,
      packer: false,
      delivery: false
    };
  },
  mounted() {
    this.CheckUserRole();
  },
  props: ["vendorId"],
  methods: {
    CheckUserRole() {
      let type = this.userRole.type;
      let access = this.userRole.permission;
      if (type == "admin") {
        this.admin = true;
      }
      if (type == "vendor") {
        if (access == "admin") {
          this.vendor = true;
        }
        if (access == "packer") {
          this.packer = true;
        }
        if (access == "delivery") {
          this.delivery = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      userRole: "getRole"
    })
  },
  watch: {
    user() {
      this.CheckUserRole();
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-link {
  color: #fff !important;
}
</style>
